// extracted by mini-css-extract-plugin
module.exports = {"floatingPanel":"FloatingPanel-module__floatingPanel___psnDP","sticky":"FloatingPanel-module__sticky___IfmaW"};